import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserSessionResponse } from '../../shared/types/user.types';
import { ApiResponse } from '../../shared/types/pqrs-api.types';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserSessionService {
  private readonly API_BASE_URL = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getUserSessionByFbToken(fbToken: string): Observable<ApiResponse<UserSessionResponse>> {  
    const headers = new HttpHeaders({
      'fb-token': fbToken,
      'Content-Type': 'application/json'
    });

    const url = `${this.API_BASE_URL}/api/auth/user-session`;

    return this.http.get<ApiResponse<UserSessionResponse>>(url, { headers });
  }
}
